import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  routes: [{
    path: '*',
    redirect: '/home'
  },
  {
    path: '/:id(\\d+)',
    name: '个人网站访问入口',
    component: () => import('@/view/userWebsideIn.vue')
  },
  {
    path: '/wwwForward',
    name: '官网站访问入口',
    component: () => import('@/view/wwwForward.vue')
  },
  {
    path: '/proxylogin*',
    name: '分公司代登录入口',
    component: () => import('@/view/proxyLoginIn.vue')
  },

  {
    path: '/thirdPayResult*',
    name: '第三方支付完成跳转地址（支付成功、失败、取消支付）',
    component: () => import('@/view/thirdPayResult.vue')
  },

  {
    path: '/findPassCheck*',
    name: '找回密码，验证链接是否有效',
    component: () => import('@/view/findPassCheck.vue')
  },

  {
    path: '/resetPassword',
    name: '找回密码-设置密码',
    component: () => import('@/view/login/resetPass.vue')
  },

  {
    path: '/verifyEmailCheck*',
    name: '邮箱验证',
    component: () => import('@/view/verifyEmailCheck.vue')
  },

  {
    path: '/errorPage',
    name: '404页面',
    component: () => import('@/view/404.vue')
  },

  {
    path: '/linkNoActive',
    name: '未激活错误提示',
    component: () => import('@/view/linkNoActive.vue')
  },

  {
    path: '/',
    component: () => import('@/view/index.vue'),
    name: '商城',
    redirect: '/home', // 重定向产品首页
    children: [
      {
        path: 'home',
        name: '产品首页',
        component: () => import('@/view/home/home.vue')
      },
      {
        path: 'categoryProduct',
        name: '分类产品',
        component: () => import('@/view/product/categoryProduct.vue')
      },
      {
        path: 'searchProduct',
        name: '搜索产品',
        component: () => import('@/view/product/searchProduct.vue')
      },
      {
        path: 'allProduct',
        name: '全部产品',
        component: () => import('@/view/product/allProduct.vue')
      },
      {
        path: 'promoPorduct',
        name: '促销产品',
        component: () => import('@/view/product/promoPorduct.vue')
      },
      {
        path: 'moreProduct',
        name: '更多产品',
        component: () => import('@/view/product/moreProduct.vue')
      },
      {
        path: 'recommendProduct',
        name: '推荐产品',
        component: () => import('@/view/product/recommendProduct.vue')
      },
      {
        path: 'aboutMe',
        name: '关于我的',
        component: () => import('@/view/personal/website/aboutMe.vue')
      },
      {
        path: 'productDetail',
        name: '产品详情',
        component: () => import('@/view/product/productDetail.vue')
      },
      {
        path: 'packageDetail',
        name: '产品包详情',
        component: () => import('@/view/product/packageDetail.vue')
      }
    ]
  },

  {
    path: '/promotion',
    name: '商城促销',
    component: () => import('@/view/home/promotion.vue')
  },

  {
    path: '/user',
    component: () => import('@/view/user.vue'),
    name: '我的',
    redirect: '/user/center', // 重定个人中心主界面
    children: [
    {
      path: 'center',
      name: '个人中心',
      component: () => import('@/view/personal/center.vue')
    },
    {
      path: 'upgradeRegister',
      name: '升级注册',
      component: () => import('@/view/personal/register/upgradeRegister.vue')
    },

    {
      path: 'index',
      name: '菜单界面',
      component: () => import('@/view/personal/index.vue'),
      redirect: '/user/order/orderList', // 重定个人中心主界面
      children: [
            // 订单管理
        {
          path: '/user/order/orderList',
          name: '订单列表',
          component: () => import('@/view/personal/order/orderList.vue')
        },
        {
          path: '/user/order/orderDetail',
          name: '订单详情',
          component: () => import('@/view/personal/order/orderDetail.vue')
        },
        {
          path: '/user/order/wishList',
          name: '收藏列表',
          component: () => import('@/view/personal/order/wishList.vue')
        },

            // 账户设置
        {
          path: '/user/setting/personalInfo',
          name: '个人信息',
          component: () => import('@/view/personal/setting/personalInfo.vue')
        },
        {
          path: '/user/setting/address',
          name: '邮寄地址',
          component: () => import('@/view/personal/setting/address.vue')
        },
        {
          path: '/user/setting/security',
          name: '安全设置',
          component: () => import('@/view/personal/setting/security.vue')
        },
        {
          path: '/user/setting/modifyPassword',
          name: '修改密码',
          component: () => import('@/view/personal/setting/modifyPassword.vue')
        },
        {
          path: '/user/setting/verifyEmail',
          name: '验证邮箱',
          component: () => import('@/view/personal/setting/verifyEmail.vue')
        },

            // 代客注册
        {
          path: '/user/proxyRegister/proxyUserList',
          name: '代注册会员列表',
          component: () => import('@/view/personal/register/proxyUserList.vue')
        },
        {
          path: '/user/proxyRegister/register',
          name: '代客注册',
          component: () => import('@/view/personal/register/register.vue')
        },
        {
          path: '/user/proxyRegister/shopping',
          name: '代客购物',
          component: () => import('@/view/personal/register/shopping.vue')
        },
        {
          path: '/user/proxyRegister/orderConfirm',
          name: '订单确认',
          component: () => import('@/view/personal/register/orderConfirm.vue')
        },

        {
          path: '/user/proxyRegister/paySuccess',
          name: '订单支付成功',
          component: () => import('@/view/personal/register/paySuccess.vue')
        },

        {
          path: '/user/proxyRegister/payFail',
          name: '订单支付失败',
          component: () => import('@/view/personal/register/payFail.vue')
        },
        {
          path: '/user/proxyRegister/payCancel',
          name: '订单支付取消',
          component: () => import('@/view/personal/register/payCancel.vue')
        },
        {
          path: '/user/proxyRegister/orderFail',
          name: '下单失败',
          component: () => import('@/view/personal/register/orderFail.vue')
        },
            // 电子币管理
        {
          path: '/user/account/myAccount',
          name: '我的账户',
          component: () => import('@/view/personal/account/myAccount.vue')
        },
        {
          path: '/user/account/financeList',
          name: '电子币转账记录',
          component: () => import('@/view/personal/account/financeList.vue')
        },
        {
          path: '/user/account/elTransfer',
          name: '电子币转账',
          component: () => import('@/view/personal/account/elTransfer.vue')
        },
        {
          path: '/user/account/elWithdraw',
          name: '电子币提现',
          component: () => import('@/view/personal/account/elWithdraw.vue')
        },
        {
          path: '/user/account/elWithdrawRecord',
          name: '提现记录',
          component: () => import('@/view/personal/account/elWithdrawRecord.vue')
        },
        {
          path: '/user/account/redPack',
          name: '红包管理',
          component: () => import('@/view/personal/account/redPack.vue')
        },

            // 奖金
        {
          path: '/user/bonus/bonusList',
          name: '奖金查询',
          component: () => import('@/view/personal/bonus/bonusList.vue')
        }, {
          path: '/user/bonus/bonusDetail',
          name: '奖金明细',
          component: () => import('@/view/personal/bonus/bonusDetail.vue')
        },

            // 顾客管理
        {
          path: '/user/customer/customerList',
          name: '顾客列表',
          component: () => import('@/view/personal/customer/customerList.vue')
        }, {
          path: '/user/customer/customerDetail',
          name: '顾客详情',
          component: () => import('@/view/personal/customer/customerDetail.vue')
        }, {
          path: '/user/customer/orderList',
          name: '订单列表',
          component: () => import('@/view/personal/customer/orderList.vue')
        },

            // 网站
        {
          path: '/user/website/websiteConfig',
          name: '个人网站',
          component: () => import('@/view/personal/website/websiteConfig.vue')
        }, {
          path: '/user/website/chooseProduct',
          name: '选择产品',
          component: () => import('@/view/personal/website/chooseProduct.vue')
        },

            // 网络查询
        {
          path: '/user/network/tabelView',
          name: '网络查询（tabelView）',
          component: () => import('@/view/personal/network/tabelView.vue')
        }, {
          path: '/user/network/treeView',
          name: '网络查询',
          component: () => import('@/view/personal/network/treeView.vue')
        }, {
          path: '/user/network/orgView',
          name: '网络查询',
          component: () => import('@/view/personal/network/orgView.vue')
        },
        {
          path: '/user/error',
          name: '404错误',
          component: () => import('@/view/personal/404.vue')
        }
      ]
    }
    ]
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/findPass',
    name: '找回密码',
    component: () => import('@/view/login/findPass.vue')
  },
  {
    path: '/register',
    name: '注册',
    component: () => import('@/view/login/register.vue')
  },

  {
    path: '/usregister',
    component: () => import('@/view/login/usRegister.vue'),
    name: '美国注册'
  },
  {
    path: '/registerShopping',
    name: '注册购物',
    component: () => import('@/view/login/shopping.vue')
  },
  {
    path: '/orderConfirm',
    name: '注册单确认',
    component: () => import('@/view/login/orderConfirm.vue')
  },
  {
    path: '/purchasePolicy',
    name: '购买协议',
    component: () => import('@/view/agreement/purchasePolicy.vue')
  },
  {
    path: '/privacyPolicy',
    name: '隐私协议',
    component: () => import('@/view/agreement/privacyPolicy.vue')
  },
  {
    path: '/registerPolicy*',
    name: '注册协议',
    component: () => import('@/view/agreement/registerPolicy.vue')
  },
  {
    path: '/cart',
    name: '购物车',
    component: () => import('@/view/shopcart/cart.vue')
  },
  {
    path: '/cartOrderConfirm',
    name: '购物车订单确认',
    component: () => import('@/view/shopcart/orderConfirm.vue')
  },
  {
    path: '/paySuccess',
    name: '下单成功',
    component: () => import('@/view/shopcart/paySuccess.vue')
  },
  {
    path: '/payFail',
    name: '订单支付失败',
    component: () => import('@/view/shopcart/payFail.vue')
  },
  {
    path: '/payCancel',
    name: '订货取消支付',
    component: () => import('@/view/shopcart/payCancel.vue')
  },
  {
    path: '/orderAudit',
    name: '订单审核中',
    component: () => import('@/view/shopcart/orderAudit.vue')
  },
  {
    path: '/orderFail',
    name: '下单失败',
    component: () => import('@/view/shopcart/orderFail.vue')
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js